export const SOURCES = {
    WEB: "web",
    APP: "app",
    SYSTEM: "system"
}